import React from 'react';
import { useLocation } from 'react-router-dom';
import { Menu } from '@uncinc/react-drupal-core';

import c from 'classnames';

import NavigationFooterMenuColumn from './NavigationFooterMenuColumn';

import './style.scss';

const NavigationFooterMenu = () => {
  const classNames = c('NavigationFooterMenu');
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <div className={classNames}>
      <Menu id="footer" className="o-background--grey">
        {(items) => {
          return (

            <div className="row">
              {items.map((item) => {
                const title = item.getIn(['link', 'title'], 'Untitled');
                const containerClass = item.getIn(['link', 'options', 'container_attributes', 'class', '0'], '');
                const hasChildren = item.get('has_children', false);
                const containerClassNames = c('col-md-3', containerClass);

                return (
                  <div
                    key={`menu--footer--menu-header-${title}`}
                    className={containerClassNames}
                  >
                    <h3 className="h4">{title}</h3>
                    { hasChildren
                      && <NavigationFooterMenuColumn item={item} path={currentPath} />}
                  </div>
                );

              })}
            </div>
          );
        }}
      </Menu>
    </div>
  );
};

export default NavigationFooterMenu;
